type Props = {
  title: string;
  description: string;
  pathname: string;
  noIndex?: boolean;
};

/** Meta tags are handled by Next.js generateMetadata – this component is a no-op. */
export function PageSEO(_props: Props) {
  return null;
}
